import React from "react";
import "./badge.scss";

export interface BadgeProps {
  text: string;
  backgroundColor?: string;
  textColor?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onLeftIconClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  onRightIconClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  className?: string;
  size?: "small" | "medium" | "large";
  maxWidth?: string;
  borderColor?: string;
  borderWidth?: string;
  showTooltip?: boolean;
}

export const Badge: React.FC<BadgeProps> = ({
  text,
  backgroundColor,
  textColor,
  leftIcon,
  rightIcon,
  onLeftIconClick,
  onRightIconClick,
  className = "",
  size = "medium",
  maxWidth,
  borderColor,
  borderWidth,
  showTooltip = false,
}) => {
  const [isTooltipVisible, setIsTooltipVisible] = React.useState(false);

  const handleLeftIconClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    onLeftIconClick?.(event);
  };

  const handleRightIconClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    onRightIconClick?.(event);
  };

  return (
    <div
      className={`badge badge-${size} ${className}`}
      style={{
        backgroundColor: backgroundColor,
        color: textColor,
        maxWidth: maxWidth,
        borderColor: borderColor,
        borderWidth: borderWidth,
      }}
      onMouseEnter={() => showTooltip && setIsTooltipVisible(true)}
      onMouseLeave={() => setIsTooltipVisible(false)}
    >
      {leftIcon && (
        <span
          className={`badge-icon badge-icon-left ${onLeftIconClick ? "badge-icon-clickable" : ""}`}
          onClick={onLeftIconClick ? handleLeftIconClick : undefined}
          role={onLeftIconClick ? "button" : undefined}
          tabIndex={onLeftIconClick ? 0 : undefined}
        >
          {leftIcon}
        </span>
      )}
      <span className="badge-text">{text}</span>
      {rightIcon && (
        <span
          className={`badge-icon badge-icon-right ${onRightIconClick ? "badge-icon-clickable" : ""}`}
          onClick={onRightIconClick ? handleRightIconClick : undefined}
          role={onRightIconClick ? "button" : undefined}
          tabIndex={onRightIconClick ? 0 : undefined}
        >
          {rightIcon}
        </span>
      )}
      {showTooltip && isTooltipVisible && (
        <span className="badge-tooltip">{text}</span>
      )}
    </div>
  );
};

